/*eslint no-lone-blocks: "error"*/
import React, { Suspense, useContext } from 'react';
import { Switch, RouteComponentProps } from 'react-router-dom';

import RouteWithSubRoutes from 'components/shared/RouteWithSubRoutes';
import LoadingSpinner from 'components/shared/LoadingSpinner';

import ConfigurationProvider from 'context/configuration';
import LegalRepresentativesProvider from 'context/legal-representatives-management';
import UserRoleContext from 'context/user-role/context';

import useBreadcrumbs from 'hooks/useBreadcrumbs';

import routes from './routes';

const ConfiguracionContainer = ({ history }: RouteComponentProps) => {
  const { getAccessByMenu } = useContext(UserRoleContext);

  useBreadcrumbs(history, routes);

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <ConfigurationProvider>
        <LegalRepresentativesProvider>
          <Switch>
            {routes.map((route, i) => {

              return (
                getAccessByMenu(route) && (
                  <RouteWithSubRoutes key={`${i}_${route.path}`} {...route} />
                )
              );
            })}
          </Switch>
        </LegalRepresentativesProvider>
      </ConfigurationProvider>
    </Suspense>
  );
};

export default ConfiguracionContainer;
